import { parse, isValid } from 'date-fns'

export const isValidTimeFormat = (timeString: string): boolean => {
    if (!timeString) return false

    const parsedDate = parse(timeString, 'HH:mm', new Date())
    return isValid(parsedDate)
}

export const isValidDateFormat = (dateString: string): boolean => {
    if (!dateString) return false

    const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date())
    return isValid(parsedDate)
}
